/**
 * M5c notice resolution — the durable jobs that resolve director-interest
 * notices (Appendix 3X/3Y/3Z → a board person) and substantial-holder notices
 * (603/604/605 → a holder, its holding and associates) into Cynapse.
 * The director job also retries ambiguous/unmatched rows, so it is the thing
 * to run after a person merge.
 */
import { apiClient } from './config.js';
import { waitForMaintenanceJob, type MaintenanceJobStatus } from './tools.js';

export type NoticeJob = 'resolve-director-trades' | 'resolve-holder-filings';

export interface NoticeResolutionResult {
  dry_run: boolean;
  rows: number;
  counts: Record<string, number>;
}

export async function runNoticeResolution(
  job: NoticeJob,
  dryRun: boolean,
  onProgress?: (s: MaintenanceJobStatus) => void,
): Promise<NoticeResolutionResult> {
  const { data } = await apiClient.post<{ job_id: string; note?: string }>(
    `/tools/${job}`, null, { params: { dry_run: dryRun } },
  );
  if (data.note) throw new Error('This job is already running — try again when it finishes.');
  return waitForMaintenanceJob<NoticeResolutionResult>(data.job_id, onProgress, 2000);
}
